import React from 'react';
import Context from '../../../../../context';

import api                                 from '../../../../../api';
import values                              from '../../../../../values';
import FactorsNeedPay2CompanyScreenContext from '../../../../../context/FactorsNeedPay2CompanyScreen.context';

import FactorsNeedPay2CompanyScreen from '..';

import { useQuery } from 'react-query';

import { TModal                    } from '../../../../../types/common.type';
import { FinancialCompanyNamespace } from '../../../../../types/financiallCompany.namespace';

const FactorsNeedPay2CompanyContainer: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [request, setRequest] = React.useState<FinancialCompanyNamespace.getFactorsIsNeedPay2Company>({
    page: 1,
    limit: 10,
    endAt: new Date(),
  })
  const [showModal, setShowModal] = React.useState<TModal>('NONE');
  const [isLoading, setIsLoading] = React.useState<boolean>(false);


  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  // ? Panel-wide academic year (سال تحصیلی). It has to be in the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const getPaginatedFactors = useQuery(
    [values.useQueryKeys?.companyGetFactorsIsNeedPay2Company, request, selectedYear?._id],
    () => api.get.company.getFactorsIsNeedPay2Coompany({ ...request, academicYear: selectedYear?._id })
  );

  const getAllFactors = useQuery([], () => api.get.company.priceFactorsIsNeedPay2Company());

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function payCompanyFactors(): Promise<void> {
    setIsLoading(true);
    await api.get.company.payFactorsIsNeedPay2Company();
    getPaginatedFactors.refetch();
    getAllFactors.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <FactorsNeedPay2CompanyScreenContext.Provider value={{
      request  ,
      showModal,
      setRequest       ,
      setShowModal     ,
      payCompanyFactors,
    }}>
      <FactorsNeedPay2CompanyScreen resultData={getPaginatedFactors} resultAllDate={getAllFactors} />
    </FactorsNeedPay2CompanyScreenContext.Provider>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

}

export default FactorsNeedPay2CompanyContainer;
